// Resolve the page index that the AI-note view should render.
//
// The note view tracks the active page in `selectedMenuItem`, which can hold a
// value that is out of range for the current note (its initial value is 1, and
// a previously-viewed multi-page note can leave it on a higher index). A
// weight-loss note has a single page, so an out-of-range index produced an
// empty controls array and a blank note. Clamping here guarantees we always
// render a valid page whenever the note has pages, regardless of render timing
// or remounts.
export const resolveActivePageIndex = (pagesLength, selectedIndex) => {
  const len = Number(pagesLength);
  const idx = Number(selectedIndex);
  if (!Number.isInteger(idx) || idx < 0 || !(len > 0) || idx >= len) {
    return 0;
  }
  return idx;
};
